import 'babel-polyfill'
import Vue from 'vue'
import App from '@/App'
import router from '@/router'
import store from '@/store'
import directives from '@/directives'
import filters from '@/filters'
import plugins from '@/plugins'
import { i18n } from '@/plugins/i18n'
import Session from '@/plugins/session'

let isFirstLoad = true

Vue.use(directives)
Vue.use(filters)
Vue.use(plugins)

// Router navigation guard for initial configuration loading
// Allows us to have a smooth initial loading experience and user defined home page
router.beforeEach(async (to, from, next) => {
  if (!store.getters['configuration/isLoaded'] && isFirstLoad) {
    isFirstLoad = false

    try {
      while (!Session.instance) {
        // Wait until the session instance is available
        await new Promise(resolve => setTimeout(resolve, 100))
      }
      next()
    } catch (error) {
      // Handle potential errors (e.g., redirect to an error page)
      console.error('Router initial load failed:', error)
      next({ name: 'customerservice' })
    }
  } else {
    next()
  }
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
